import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18next';

import type { BreadcrumbsState, DynamicCrumb } from './types';
import type { PayloadAction } from '@reduxjs/toolkit';

export const initialState: BreadcrumbsState = {
  dynamicCrumb: {},
};

export const breadcrumbsSlice = createSlice({
  name: 'breadcrumbs',
  initialState,
  reducers: {
    addDynamicCrumb: (
      store,
      { payload: { pathname } }: PayloadAction<Pick<DynamicCrumb, 'pathname'>>,
    ) => {
      store.dynamicCrumb[pathname] = {
        pathname,
        title: null,
        isLoading: true,
      };
    },
    addDynamicCrumbFulfilled: (
      store,
      {
        payload: { title, pathname },
      }: PayloadAction<Omit<DynamicCrumb, 'isLoading'>>,
    ) => {
      store.dynamicCrumb[pathname] = {
        pathname,
        title,
        isLoading: false,
      };
    },
    addDynamicCrumbRejected: (
      store,
      { payload: { pathname } }: PayloadAction<Pick<DynamicCrumb, 'pathname'>>,
    ) => {
      store.dynamicCrumb[pathname] = {
        pathname,
        title: i18n.t('header.breadcrumbs.defaultSubjectCrumb'),
        isLoading: false,
      };
    },
  },
});

export const { actions: breadcrumbsActions, reducer: breadcrumbsReducer } =
  breadcrumbsSlice;
